export default "__VITE_ASSET__VbxLJhAIc7PkPpTeTBakFw__"